import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Plus, SlChillPhone } from "@/assets/icons/icons.tsx";
import { ProductCard } from "@/components/Layout/BaseLayouts/ProductCard/ProductCard";
import { ProductCardFooterItem } from "@/components/Layout/BaseLayouts/ProductCard/ProductCardFooterItem";

interface AddDeviceTileProps {
  addDeviceRoute: string;
}

export const AddDeviceTile = ({ addDeviceRoute }: AddDeviceTileProps) => {
  const { t } = useTranslation("portal");
  const navigate = useNavigate();

  return (
    <ProductCard
      dataTestid="add-device-tile"
      header={
        <div className="flex h-full w-full flex-col items-start gap-3 pt-4">
          <SlChillPhone className="size-16 shrink-0" />
          <p className="w-full text-headline-md font-semibold leading-sm text-foreground-primary">
            {t("layout.tiles.addDevice.title")}
          </p>
        </div>
      }
      footer={
        <ProductCardFooterItem
          variant="button"
          label={t("layout.tiles.addDevice.button")}
          icon={<Plus />}
          onClick={() => navigate(addDeviceRoute)}
        />
      }
    />
  );
};
